import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import classNames from "classnames";

import { Dropdown } from "../ui";
import Button from "../ui/button";

import { HeaderLogo } from "../../assets/svg";
import { RxHamburgerMenu } from "react-icons/rx";
import { FaArrowLeftLong } from "react-icons/fa6";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";

const Header = ({ className }) => {
  const navigate = useNavigate();
  const [isHamburgerOpen, setIsHamburgerOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleHamburger = () => {
    setIsHamburgerOpen(!isHamburgerOpen);
  };

  const handleMenuItemClick = () => {
    setIsHamburgerOpen(false);
  };

  const dropdownTitle = (
    <div className={classNames(className, "flex gap-2 items-center")}>
      <div className="flex gap-2 items-center">
        <div className="">Business type</div>
        <div className="">
          {isDropdownOpen ? (
            <FaChevronUp color="#0D98BA" />
          ) : (
            <FaChevronDown color="#0D98BA" />
          )}
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className="fixed top-0 left-0 right-0 z-20 w-full bg-[#C2E4F0] border-b border-gray-200">
        <div className="container flex justify-between items-center h-12 lg:h-[70px] ">
          <div
            className="flex gap-1 items-center cursor-pointer"
            onClick={() => navigate("/")}
          >
            <HeaderLogo className="w-6 h-6 lg:w-8 lg:h-8" size={32} />
            <p className="text-lg font-semibold uppercase">TrainerX</p>
          </div>
          <div className="hidden lg:block">
            <ul className="flex gap-10 items-center">
              <li className="cursor-pointer">
                <Dropdown
                  className=""
                  renderTitle={dropdownTitle}
                  placement="bottom-end"
                  onClick={handleDropdown}
                >
                  <Dropdown.Item
                    className="gap-2"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  >
                    <NavLink
                      className={({ isActive }) =>
                        `menu-item-link font-medium ${
                          isActive ? " overflow-hidden text-[#0D98BA]" : ""
                        }`
                      }
                      to="/personal-trainer"
                    >
                      Personal trainer
                    </NavLink>
                  </Dropdown.Item>
                  <Dropdown.Item
                    className="gap-2"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  >
                    <NavLink
                      className={({ isActive }) =>
                        `menu-item-link font-medium ${
                          isActive ? " overflow-hidden text-[#0D98BA]" : ""
                        }`
                      }
                      to="/gym-fitness-studio"
                    >
                      Gym and fitness studio
                    </NavLink>
                  </Dropdown.Item>
                </Dropdown>
              </li>
              <li>
                <NavLink
                  key={"features"}
                  to={`/features`}
                  className={({ isActive }) =>
                    ` font-medium ${
                      isActive ? " overflow-hidden text-[#0D98BA]" : ""
                    }`
                  }
                >
                  Features
                </NavLink>
              </li>
              <li>
                <NavLink
                  key={"pricing"}
                  to={`/pricing`}
                  className={({ isActive }) =>
                    ` font-medium ${
                      isActive ? " overflow-hidden text-[#0D98BA]" : ""
                    }`
                  }
                >
                  Pricing
                </NavLink>
              </li>
              <li>
                <NavLink
                  key={"about"}
                  to={`/about`}
                  className={({ isActive }) =>
                    ` font-medium ${
                      isActive ? " overflow-hidden text-[#0D98BA] " : ""
                    }`
                  }
                >
                  About
                </NavLink>
              </li>
              <li className="flex gap-6">
                <NavLink to="https://portal.trainerx.co/">
                  <Button className="text-[#0D98BA] border-[1px] border-[#0D98BA] rounded-full">
                    Get started
                  </Button>
                </NavLink>

                {/* <NavLink to="https://portal.trainerx.co/client/sign-up">
                                    <Button className="bg-[#0D98BA] rounded-full" variant="solid"  >
                                        Get started
                                    </Button>
                                </NavLink> */}
              </li>
            </ul>
          </div>
          <div className="lg:hidden">
            <RxHamburgerMenu size={24} onClick={handleHamburger} />
          </div>
        </div>

        {isHamburgerOpen && (
          <div className="overflow-scroll fixed top-0 right-0 z-40 w-full h-full bg-white shadow-lg sm:w-1/2">
            <nav className="flex flex-col items-start">
              <div className=" border-b-[1px] border-[#000000] w-full h-12 flex items-center justify-between ">
                <div className="flex justify-between items-center w-2/3 text-center">
                  <FaArrowLeftLong
                    className="ml-4"
                    size={24}
                    onClick={() => setIsHamburgerOpen(false)}
                  />
                  <span className="text-2xl font-bold text-center font-syne">
                    Menu
                  </span>
                </div>
              </div>

              <div
                className="flex justify-between items-center px-4 pt-4 pb-2 w-full"
                onClick={() => handleDropdown()}
              >
                <div>
                  <p className="flex w-full font-medium">Business type</p>
                </div>
                <div className="pr-4">
                  {isDropdownOpen ? (
                    <FaChevronUp color="#0D98BA" size={16} />
                  ) : (
                    <FaChevronDown color="#0D98BA" size={16} />
                  )}
                </div>
              </div>

              {isDropdownOpen ? (
                <>
                  <div className="items-center mx-auto w-11/12">
                    <div className="px-4 py-2">
                      <NavLink
                        className={({ isActive }) =>
                          `menu-item-link font-medium ${
                            isActive ? " overflow-hidden text-[#0D98BA]" : ""
                          }`
                        }
                        to="/personal-trainer"
                        onClick={handleMenuItemClick}
                      >
                        Personal trainer
                      </NavLink>
                    </div>
                    <div className="px-4 py-2">
                      <NavLink
                        className={({ isActive }) =>
                          `menu-item-link font-medium ${
                            isActive ? " overflow-hidden text-[#0D98BA]" : ""
                          }`
                        }
                        to="/gym-fitness-studio"
                        onClick={handleMenuItemClick}
                      >
                        Gym and fitness studio
                      </NavLink>
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}

              <div className="px-4 py-2">
                <NavLink
                  key={"features"}
                  to={`/features`}
                  className={({ isActive }) =>
                    ` font-medium  ${
                      isActive ? " overflow-hidden text-[#0D98BA]" : ""
                    }`
                  }
                  onClick={handleMenuItemClick}
                >
                  Features
                </NavLink>
              </div>

              <div className="px-4 py-2">
                <NavLink
                  key={"pricing"}
                  to={`/pricing`}
                  className={({ isActive }) =>
                    ` font-medium  ${
                      isActive ? " overflow-hidden text-[#0D98BA]" : ""
                    }`
                  }
                  onClick={handleMenuItemClick}
                >
                  Pricing
                </NavLink>
              </div>

              <div className="px-4 py-2">
                <NavLink
                  key={"about"}
                  to={`/about`}
                  className={({ isActive }) =>
                    ` font-medium  ${
                      isActive ? " overflow-hidden text-[#0D98BA] " : ""
                    }`
                  }
                  onClick={handleMenuItemClick}
                >
                  About
                </NavLink>
              </div>

              <div>
                <div
                  className={`flex gap-2 justify-start items-center px-4 pt-6`}
                >
                  <NavLink
                    to="https://portal.trainerx.co/"
                    onClick={handleMenuItemClick}
                  >
                    <Button className="text-[#0D98BA] border-[1px] border-[#0D98BA] rounded-full">
                      Get started
                    </Button>
                  </NavLink>

                  {/* <NavLink to="https://portal.trainerx.co/client/sign-up" onClick={handleMenuItemClick}>
                                        <Button className="bg-[#0D98BA] rounded-full" variant="solid"  >
                                            Get started
                                        </Button>
                                    </NavLink> */}
                </div>
              </div>
            </nav>
          </div>
        )}
      </div>
    </>
  );
};

export default Header;
